/**
 * @Author chenguanbin
 * @Date 2020-01-17 15:15:08
 * @Desc 表格操作公共属性和方法
 */
export default {
  data() {
    return {
      pagination: {
        total: 0, // 数据总数量
        pageNo: 1, // 当前页码
        pageSize: 20 // 每页显示条数
      }
    }
  },
  methods: {
    /**
     * @author chenguanbin
     * @date 2020-01-17 15:24:07
     * @desc 切换每页显示条数
     * @param {Number} pageSize 每页显示条数
     */
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.refreshTable()
    },

    /**
     * @author chenguanbin
     * @date 2020-01-17 15:24:20
     * @desc 切换当前页码
     * @param {Number} pageNo 当前页码
     */
    handleCurrentChange(pageNo) {
      this.pagination.pageNo = pageNo
      this.refreshTable()
    },

    /**
     * @author chenguanbin
     * @date 2020-01-19 19:13:17
     * @desc 查询
     */
    handleSearch() {
      this.pagination.pageNo = 1
      this.refreshTable()
    },

    /**
     * @author chenguanbin
     * @date 2020-01-19 19:13:23
     * @desc 重置
     */
    handleReset() {
      this.$refs.search.getForm().resetFields()
      this.refreshTable()
    }
  }
}
